import React from 'react';

/**
 * @template {{}} P
 * @param {React.ComponentType<P>} BaseComponent
 * @param {Partial<P>} baseProps
 * @returns {React.ComponentType<P>}
 */
export default function withProps(BaseComponent, baseProps) {
    return React.forwardRef(function WithPropsWrapper(props, ref) {
        return <BaseComponent ref={ref} {...baseProps} {...props} />;
    });
}